export default {
  expirationSettings: 'Paramètres d\'expiration',
  inactivityInterval: 'Intervalle d\'inactivité',
  expirationInterval: 'Intervalle d\'expiration',
  inactivityIntervalHelpText: 'Définit quand l\'utilisateur est compté comme inactif',
  expirationIntervalHelpText: 'Définit la période d\'inactivité après laquelle le jeton d\'authentification expire',
  selectTemplate: 'Sélectionnez le modèle',
};
